import {
  Box,
  Stack,
  useTheme,
  useMediaQuery,
  Typography,
  Skeleton,
} from '@mui/material';

export default function ArticleHeaderSkeleton() {
  const theme = useTheme();
  const isMobileScreen = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Box>
      <Stack
        direction={isMobileScreen ? 'row' : 'column'}
        sx={{
          alignItems: isMobileScreen ? 'center' : 'start',
          justifyContent: 'space-between',
        }}
      >
        <Box
          sx={{
            width: '100%',
          }}
        >
          <Typography
            component='span'
            variant={isMobileScreen ? 'body2' : 'h6'}
          >
            <Skeleton />
          </Typography>
        </Box>
        {!isMobileScreen && (
          <Typography
            variant='body2'
            paddingTop={7}
            paddingBottom={1}
            width='100%'
          >
            <Skeleton />
          </Typography>
        )}
      </Stack>
    </Box>
  );
}
